import { Controller } from "@hotwired/stimulus"

// Generic Ahoy event tracker for funnel steps.
//
//   Fire on click:    data-action="click->track#fire"
//   Fire on pageview: data-track-on-connect-value="true"
//
// Reads the event name + label from values, mirroring outbound_controller.
export default class extends Controller {
  static values = {
    event: String,
    label: String,
    onConnect: Boolean
  }

  connect() {
    if (this.onConnectValue) this.fire()
  }

  fire() {
    if (window.ahoy) {
      ahoy.track(this.eventValue, { label: this.labelValue })
    }
  }
}
